import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inter',
  templateUrl: './inter.component.html',
  styleUrls: ['./inter.component.scss']
})
export class InterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
